module.exports = __webpack_public_path__ + "img/dice3.90734f10.svg";